var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgProjectsTableHeaderList = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 12,
  height: 8,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 4.667h1.333V3.333H0zm0 2.666h1.333V6H0zM0 2h1.333V.667H0zm2.667 2.667H12V3.333H2.667zm0 2.666H12V6H2.667zm0-6.666V2H12V.667zM0 4.667h1.333V3.333H0zm0 2.666h1.333V6H0zM0 2h1.333V.667H0zm2.667 2.667H12V3.333H2.667zm0 2.666H12V6H2.667zm0-6.666V2H12V.667z"
})));
export default SvgProjectsTableHeaderList;